import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

export default function AIDisclaimer() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <SEOHead 
        title="AI-Generated Content Disclaimer | Woods Spine & Wellness"
        description="Read our AI-generated content disclaimer regarding information provided on the Woods Spine & Wellness website."
        canonical="https://woodsspine.com/ai-disclaimer"
      />
      <Navbar />
      <main className="flex-grow pt-32 pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-primary mb-8">AI-Generated Content Disclaimer</h1>
          
          <div className="prose prose-lg dark:prose-invert max-w-none space-y-6 text-muted-foreground">
            <p>
              Some of the content on this website may be created or assisted by artificial intelligence ("AI") tools. While we strive for accuracy and usefulness, AI-generated content may contain errors, omissions, or reflect outdated information.
            </p>
            
            <p>
              This content is provided for informational purposes only and should not be considered professional advice (including legal, medical, or financial advice). You should not rely solely on AI-generated content and are encouraged to verify information independently or consult a qualified professional where appropriate.
            </p>
            
            <p>
              Veloce Solutions nor Woods Spine & Wellness does not assume any responsibility or liability for the accuracy, completeness, or usefulness of AI-generated content, or for any actions taken based on such content. We reserve the right to modify, update, or remove AI-generated material at any time without notice.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
